define('plugins/musicfavourite/nls/artist/confirmation',{
    'en-gb': {
        'confirmation': {
            'added': 'Artist added, go to',
            'link': 'My Music',
            'afterLink': 'to see full list.'
        }
    },
    // TODO MC-1916: Update Welsh, Irish and Scottish 'Added' translations to include profile type.
    'cy-gb': { //WELSH
        'confirmation': {
            'added': 'Ychwanegwyd, ewch i',
            'link': 'Fy Ngherddoriaeth',
            'afterLink': 'i weld y rhestr llawn.'
        }
    },
    'ga-gb': { //IRISH
        'confirmation': {
            'added': 'Curtha leis, t&eacute;igh go',
            'link': 'Mo Cheol',
            'afterLink': 'le liosta ioml&aacute;n a fheice&aacute;il.'
        }
    },
    'gd-gb': { //SCOTTISH
        'confirmation': {
            'added': 'Air a chur ris, rach gu',
            'link': 'Mo Che&ograve;l',
            'afterLink': 'airson an liosta sl&agrave;n fhaicinn.'
        }
    }
});

